<section id="mass-os-service-types" class="mass-os-service-types mass-os-services-card">
  <header class="mass-os-card__header">
    <div class="mass-os-card__icon" aria-hidden="true">
      <mat-icon>category</mat-icon>
    </div>
    <div class="mass-os-card__text">
      <h3 class="mass-os-card__title">Servicios</h3>
      <p class="mass-os-card__context">
        Filtra por tipo de servicio a incluir en las órdenes.
      </p>
    </div>
  </header>

  <label class="mass-os-label">
    Servicios <span class="mass-os-label__req">*</span>
  </label>

  <div class="mass-os-service-types__chips">
    <button
      type="button"
      class="mass-os-chip"
      [class.mass-os-chip--selected]="allServicesSelected"
      (click)="onToggleAll()"
    >
      <i-tabler name="category" class="mass-os-chip__icon"></i-tabler>
      <span>Todos los servicios</span>
    </button>

    <button
      *ngFor="let service of serviceTypes; trackBy: trackByService"
      type="button"
      class="mass-os-chip"
      [class.mass-os-chip--selected]="serviceTypeIds.includes(service.id)"
      (click)="onToggleService(service.id)"
    >
      <i-tabler
        [name]="service.icon || 'dots'"
        class="mass-os-chip__icon"
      ></i-tabler>
      <span>{{ service.label }}</span>
    </button>
  </div>

  <span class="mass-os-service-types__error" role="alert">{{
    serviceTypesError
  }}</span>
</section>
